export type PackId = "free" | "pack_100" | "pack_200"

export interface PackFeature {
  label: string
  included: boolean
}

export interface PaymentOption {
  id: PackId
  name: string
  badge: string | null
  billingLabel: string
  ctaLabel: string
  creditsGranted: number
  features: PackFeature[]
  razorpayAmountPaise: number
}

export const FREE_TRIAL_CREDITS = 20
export const LOW_CREDITS_THRESHOLD = 10

const PAYMENT_OPTIONS: PaymentOption[] = [
  {
    id: "free",
    razorpayAmountPaise: 0,
    name: "Free Trial",
    badge: null,
    billingLabel: "no credit card required",
    ctaLabel: "Get Started Free",
    creditsGranted: FREE_TRIAL_CREDITS,
    features: [
      { label: `${FREE_TRIAL_CREDITS} AI images included`, included: true },
      { label: "Priority support", included: false }
    ]
  },
  {
    id: "pack_100",
    name: "100 Image Credits",
    badge: "Most Popular",
    billingLabel: "one-time purchase",
    ctaLabel: "Buy 100 Credits",
    creditsGranted: 100,
    razorpayAmountPaise: 49900,
    features: [
      { label: "100 AI images", included: true },
      { label: "Never expires", included: true },
      { label: "Priority support", included: true }
    ]
  },
  {
    id: "pack_200",
    name: "225 Image Credits",
    badge: "Best Value",
    billingLabel: "one-time purchase",
    ctaLabel: "Buy 225 Credits",
    creditsGranted: 225,
    razorpayAmountPaise: 99900,
    features: [
      { label: "225 AI images", included: true },
      { label: "Never expires", included: true },
      { label: "Priority support", included: true }
    ]
  }
]

export { PAYMENT_OPTIONS }

export type Pack = PaymentOption
